import { callAuthorizedGraphQLEndpoint } from '../../../../../Module/graphQL'

const createCampaignDocument = input => {
  const query = `mutation ($input:CreateCampaignDocumentInput) {
      createCampaignDocument(input:$input){ 
          campaignId
          uploaderId
          type
          url
          isActual
      }
    }
    `

  return callAuthorizedGraphQLEndpoint(query, { input })
}

const updateCampaignDocument = input => {
  const query = `mutation ($input:UpdateCampaignDocumentInput) {
      updateCampaignDocument(input:$input){ 
          campaignId
          uploaderId
          type
          url
          isActual
      }
    }
    `

  return callAuthorizedGraphQLEndpoint(query, { input })
}

const getData = args => {
  const { campaignId } = args
  const query = `query getData($campaignId:ID!){
      getCampaignDocuments(campaignId:$campaignId){
          id
          campaignId
          uploaderId
          type
          url
          isActual
          fileName
      }
      campaign(id:$campaignId){
          isDigitalProofSentToClient
          name
          trackingType
          countryId
          type
          subtype
      }
      campaignExtraData(campaignId:$campaignId){
          internalStatus
          createdAt
          couponType
       }
      campaignFlyerInfo(campaignId: $campaignId) {
          s3Link
          flyerName
          activeRoomId
      }
      campaignClientCodes(campaignId: $campaignId) {
          trackingType
          campaignId
          clientCodes{
            id
            clientCode
            clientLink
            city{
              id
              name
            }
          }
        }
        campaignInternalCodes(campaignId: $campaignId) {
            campaignId
            internalCodes{
              id
              internalCode
              internalLink
              city{
                id
                name
              }
            }
          }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}

const updateCampaignsCampaignBuilderData = input => {
  const query = `mutation updateCampaignExtraData(
      $input: CampaignExtraDataInput
    ) {
      updateCampaignExtraData(
        input: $input,
      ) { 
        success
        error
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, input)
}

const getUSCityDistributionChannels = async countryId => {
  const query = `query ($countryId: ID!) {
    country (id: $countryId) {
      citiesSettings {
        nodes {
          id,
          name, 
          enabledChannelPreciseLocations,
          enabledChannelBroadAreas,
          enabledChannelLetterbox,
        }
      },
    }
  }`
  const response = await callAuthorizedGraphQLEndpoint(query, { countryId })
  const {
    data: { country },
  } = await response.json()
  return {
    citiesSettings: country.citiesSettings.nodes,
  }
}

const getCountrySettings = async countryId => {
  const query = `query ($countryId: ID!) {
    country (id: $countryId) {
      citiesSettings {
        nodes {
          id,
          name, 
          enabledChannelPreciseLocations,
          enabledChannelBroadAreas,
          enabledChannelLetterbox,
          h2hDistributionCosts,
          d2dDistributionCosts,
          bonusBa,
          baPayout,
          outfitCosts,
          permitCostsD2d,
          permitCostsH2h,
          travelCosts,
          minimumMissionLimit,
          weeklyMissionLimit,
          flyerPackH2h,
          flyerPackD2d,
          lunchCheckInTime,
          afternoonCheckInTime,
          timezone,
        }
      },
      countryDefaultSettings {
        h2hDistributionCosts,
        d2dDistributionCosts,
        bonusBa,
        baPayout,
        outfitCosts,
        permitCostsD2d,
        permitCostsH2h,
        travelCosts,
        minimumMissionLimit,
        weeklyMissionLimit,
        flyerPackH2h,
        flyerPackD2d,
        countryTaxRate,
      }
    }
  }`
  const response = await callAuthorizedGraphQLEndpoint(query, { countryId })
  const {
    data: { country },
  } = await response.json()
  return {
    countryDefaultSettings: country.countryDefaultSettings,
    citiesSettings: country.citiesSettings.nodes,
  }
}

const getCampaignAudience = async campaignId => {
  const query = `query ($campaignId: ID!) {
    campaignAudience(campaignId: $campaignId) {
      id
      firstName
      lastName
      email
      address
      city
      state
      zipCode
      customFields
    }
  }`
  const response = await callAuthorizedGraphQLEndpoint(query, { campaignId })
  const { data } = await response.json()
  return data.campaignAudience
}

export {
  getData,
  createCampaignDocument,
  updateCampaignDocument,
  updateCampaignsCampaignBuilderData,
  getCountrySettings,
  getUSCityDistributionChannels,
  getCampaignAudience,
}
